<template>
    <div class="view-selections-cta__wrapper">
        <div class="view-selections-cta__wrapper-cost-summary" role="group" aria-labelledby="cost-summary-label">
            <span id="cost-summary-label" class="view-selections-cta__cost-summary-label">
                Total Cost ({{ totalItems }} items)
            </span>
            <span class="view-selections-cta__cost-summary-price">{{ formattedPrice }}</span>
        </div>
        <button class="btn btn--secondary btn--medium view-selections-cta__wrapper-view-sel-cta"
            :disabled="!Boolean(totalItems)" @click="onViewSelectionsClick">
            View Selections
        </button>
    </div>
</template>


<script setup>
import { computed, reactive } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
    onViewSelectionsClick: {
        type: Function,
        default: () => { }
    },
});

const store = useStore();
const selectedProductsFromContext = reactive(store.state.byk.selectedProducts);

const totalItems = computed(() => (
    Object.values(selectedProductsFromContext)
        .flatMap(layer => Object.values(layer))
        .flat()
        .length
));

const totalPrice = computed(() => {
    return Object.values(selectedProductsFromContext)
        .flatMap(layer => Object.values(layer))
        .flat()
        .reduce((total, item) => {
            const customerDiscountVal = window.customerDiscount(item.tags);
            const variant = item.variants.find((vrnt) => vrnt.available === true && vrnt.color === item.selectedVariantDetails?.color);
            const discountedPrice = getPrice(variant.price/100, variant.compare_at_price/100, customerDiscountVal);

            return total + discountedPrice;
        }, 0);
});

const formattedPrice = computed(() => window.formattedPrice(totalPrice.value));

const getPrice = (price, compareAtPrice, customerDiscountVal) => {
    if (compareAtPrice > 0) {
        if (compareAtPrice * (1 - customerDiscountVal) < price) {
            return compareAtPrice * (1 - customerDiscountVal);
        } else {
            return price;
        }
    } else {
        return (price) * (1 - customerDiscountVal);
    }
};

const discountPriceLogic = (price, compareAtPrice, customerDiscountVal) => {
    if (compareAtPrice > 0) {
        if (compareAtPrice * (1 - customerDiscountVal) < price) {
            return (compareAtPrice) * (1 - customerDiscountVal)
        } else {
            return (price);
        }
    } else {
        return (price) * (1 - customerDiscountVal);
    }
};

</script>
